import React from 'react';

import { useLaizeCalcDialogState } from '../LaizeCalcDialogProvider';
import { MapUIRoomItem } from './MapUIRoomItem';

import { IRoomItem } from 'Plugins/FloorPlan/Models/IRoomItem';
import { SvgAttributesWith } from 'Plugins/FloorPlan/Widgets/SvgTypes';

type MapUIRoomItemsProps = { roomItems?: IRoomItem[] };
export const MapUIRoomItems = (props: SvgAttributesWith<unknown>) => {
    const { roomType: type, roomItems = [], rooms = [] } = useLaizeCalcDialogState();
    const roomIds = rooms.filter((room) => room.type === type).map((room) => room.roomId!);
    const roomItemsToDisplay = roomItems.filter((item) => roomIds.includes(item.roomId!) || !item.roomId);
    return <RawMapUIRoomItems roomItems={roomItemsToDisplay} {...props} />;
};

export const RawMapUIRoomItems = ({ roomItems = [], ...attrs }: SvgAttributesWith<MapUIRoomItemsProps>) => {
    return (
        <g id="mapRoomItems" {...attrs}>
            {roomItems.map((roomItem) => (
                <MapUIRoomItem key={roomItem.roomItemId} item={roomItem} />
            ))}
        </g>
    );
};
